// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__LVJyw","insightsList":"newBusinessInsightsMenu_insightsList__2UARt","active":"newBusinessInsightsMenu_active__qQZa4"};